import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { generalService } from '../../services/general.service';
import { Item } from '../../models/item';
import { ItemSat } from '../../models/item-sat';
import { MatOptionSelectionChange, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { ItemSubFamily } from '../../models/item-subfamily';
import { MatSelect } from '@angular/material/select';
import { DataService } from '../../utils/data.service';

@Component({
    selector: 'app-add-itemSat',
    templateUrl: 'itemSat-agregar-editar.html',
    styleUrls: [],
    providers: [generalService]
  })

  export class ItemSatAddEditComponent implements OnInit {
    private ItemSat :ItemSat = new ItemSat();;
    public title = '';
    private loacs: string;
    private ITEM_SAT_ID = undefined;
    public itemSatFrom: FormGroup;
    public dataItemSat: any[] = [];
    public status = "";
    public Item_Name = "";
    public actualizar = false;
    constructor(private router: Router,private formBuilder: FormBuilder,public dataService: DataService,
      private _generalService: generalService,private route: ActivatedRoute,) {}

    ngOnInit(){
        this. buildVehiculoForm()
        this.ITEM_SAT_ID = this.dataService.dialogRef._containerInstance._config.data.ITEM_SAT_ID;
        this.validateRoute(this.ITEM_SAT_ID);
    }


    validateRoute(ITEM_SAT_ID:number) {
      if (this.ITEM_SAT_ID === 0) {
        this.title = 'guardado';
        this.status = "Agregar";
      }else{
        this.consultarDataItemSat();
        this.title = 'actualizado';
        this.status = "Actualizar";
       
      }
    }



    cerrarModal() {
        this.dataService.dialogRef.close();
    }

    buildVehiculoForm() {    
      this.itemSatFrom = this.formBuilder.group({
        // General data
        nameSat: this.formBuilder.control(null, [Validators.required]), 
        descripcionSat: this.formBuilder.control(null, [Validators.required])
      });
    }
    consultarDataItemSat(){
      
      let metodo = 'Item/consultDataItemSat';
     
      const params = { 
          loacs: sessionStorage.getItem('acslo'),
          ITEM_SAT_ID:this.ITEM_SAT_ID
      };

      this._generalService.metodoCallParams(params, metodo).subscribe(
        result => {
          const tableResult = JSON.parse(result);
          this.dataItemSat = tableResult; 
          
          if (tableResult !== undefined){
            this.itemSatFrom.get('nameSat').setValue(this.dataItemSat[0].NAME_SAT);
            this.itemSatFrom.get('descripcionSat').setValue(this.dataItemSat[0].DESCRIPTION);
            this.Item_Name =  this.dataItemSat[0].NAME_SAT + ' - ';
          } 
        },
        error => {  console.log(<any>error);  }
      );
    }
    guardarItemSat() {
      this.mapearDatosFormularioEnModelo();
      this.agregarItemSat();
    }
    mapearDatosFormularioEnModelo() {
      this.ItemSat.NAME_SAT = this.itemSatFrom.controls['nameSat'].value;
      this.ItemSat.DESCRIPTION = this.itemSatFrom.controls['descripcionSat'].value;
      this.ItemSat.ITEM_SAT_ID = this.ITEM_SAT_ID
      this.ItemSat.loacs =  sessionStorage.getItem('acslo');
    }
    
    agregarItemSat() {
      this._generalService.metodoCallParams(this.ItemSat, 'Item/addEditItemSat',true).subscribe(
        (result) => {
            this.cerrarModal();
          this._generalService.toastCall('Registro '+ this.title +' exitosamente!');
          }, (error) => {
            console.log(error as any);
          });
    }
  }



// WEBPACK FOOTER //
// ./src/app/itemSat/agregar-editar/itemSat-agregar-editar.ts